export const APP_TENANT = process.env.UBIK_TRACKING_TENANT || 'vistaprint'
export const WEBSITE_DOMAINS_LOCALES = [
  'en-us',
  'en-gb',
  'en-ca',
  'en-au',
  'en-nz',
  'en-sg',
  'en-ie',
  'en-in',
  'fr-fr',
  'fr-ca',
  'de-de',
  'fr-ch',
  'de-at',
  'de-ch',
  'nl-nl',
  'nl-be',
  'fr-be',
  'es-es',
  'it-it',
  'it-ch',
  'nb-no',
  'da-dk',
  'sv-se',
  'fi-fi',
  'pt-pt',
  'es-us',
]
export const TRY_THE_BEST_LOCALES = ['en-us', 'es-us', 'en-ca', 'fr-ca']
export const YELP_LOCALES = ['en-us', 'es-us', 'en-ca', 'fr-ca']
export const LEGALZOOM_WIX_WEBSITES_LOCALES = ['en-us']
export const DOMAIN_OFFERING_PARTNER_NAME = 'WIX'
export const TEST_USER_ID = 'd2FyaG9s-8593DF9C6AE9DBE704D7A774837FE532'
export const BUSINESS_CARD_MPV_ID = 'standardBusinessCards'
export const SURVEY_FEEDBACK_LOCALES = ['en-us', 'en-gb', 'en-au', 'en-ca', 'en-nz', 'en-sg', 'en-ie', 'en-in']
// TODO: Update the following value when the release date is known
export const BRAND_BUILDER_RELEASE_DATE = new Date('2025-04-29')
export enum LogomakerLogoLayoutVariantType {
  CIRCULAR_NO_BORDERS = 'circular',
  CIRCULAR_INNER_BORDER = 'circularInnerBorder',
  CIRCULAR_OUTER_BORDER = 'circularOuterBorder',
  CIRCULAR_DOUBLE_BORDER = 'circularDoubleBorder',
  STACKED = 'stacked',
  STACKED_LEFT = 'stackedLeft',
  ICON_LEFT = 'iconLeft',
  ICON_RIGHT = 'iconRight',
  ICON_IN_MIDDLE = 'iconMiddle',
  TEXT_ARC = 'textArc',
}
export enum LogoBrandWordMarkVariantType {
  BRAND_MARK = 'brandMark',
  WORD_MARK = 'wordMark',
}

export const noop = () => {}
export const noopWithArgs = (...args: any[]) => {}
